(function(angular, schoolwork12) {
'use strict';
angular.module(schoolwork12.app.student.name)
    .factory(schoolwork12.app.student.services.manageStudentDataSvc, ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {

            var getFundingModelTypes = function (keycode) {
                console.info('In getFundingModelTypes service');
                console.info('Making a call to service');
               // return [{'code': 'FT'}, {'code': 'PT'}];
                var fundingModelTypes = null;
                var deferred = $q.defer();
                 var request = $http({
                     method: 'GET',
                     url: schoolwork12.app.student.endpoints.getFundingModelypesEndpoint,
                     headers: {
                         'Content-Type': 'application/json',
                         'X-API-TOKEN': keycode
                     }
                });
                 request.then(function (response) {
                     fundingModelTypes = response.data;
                     deferred.resolve(fundingModelTypes);
                     console.info('Got the funding model types');
                 }, function (error) {  
                     deferred.reject(error);
                 });
                 return deferred.promise;
            };  

            var getSavedSearchbyPerson = function (keycode, personId) {
                console.info('In getSavedSearchbyPerson service');
                console.info('Making a call to service');
                $rootScope.actionCompletedSuccessfully = false;
                $rootScope.actionCompletedSuccessfullyMessage = '';

                var savedSearchbyPerson = null;
                var deferred = $q.defer();
                var request = $http({
                     method: 'GET',
                     url: schoolwork12.app.student.endpoints.saveStudentSearchPerson + personId,
                     headers: {
                         'Content-Type': 'application/json',
                         'X-API-TOKEN': keycode
                     }
                });
                 request.then(function (response) {
                     savedSearchbyPerson = response.data;
                     deferred.resolve(savedSearchbyPerson);
                     console.info('Got the saved search by Person ID');
                     if($rootScope.searchDeleted && $rootScope.removeSearch){
                        $rootScope.actionCompletedSuccessfully = true;
                        $rootScope.actionCompletedSuccessfullyMessage = "You have successfully deleted search."
                     }
                 }, function (error) {  
                     deferred.reject(error);
                 });
                 return deferred.promise;
            };  

              var deleteSavedSearchbyPerson = function (keycode, item) {
                console.info('In deleteSavedSearchbyPerson service');
                console.info('Making a call to service');
                $rootScope.searchDeleted = false;
                var savedSearch = null;
                var deferred = $q.defer();
                var request = $http({
                     method: 'PUT',
                     url: schoolwork12.app.student.endpoints.saveStudentSearch,
                     data : {
                                name: item.name,
                                description: item.description,
                                id: item.id,
                                shareSchoolId: item.shareSchoolId,
                                shareRoleId: item.shareRoleId,
                                notShareSchoolId: item.notShareSchoolId,
                                notShareRoleId: item.notShareRoleId,
                                shareSave: item.shareSave,
                                studentSearchRequest: item.content,
                                status: 0
                            },
                     headers: {
                         'Content-Type': 'application/json',
                         'X-API-TOKEN': keycode
                    }
                });
                 request.then(function (response) {
                     savedSearch = response.data;
                     deferred.resolve(savedSearch);
                     $rootScope.searchDeleted = true;
                     console.info('Deleted the saved search by Person ID ');
                 }, function (error) {  
                     deferred.reject(error);
                 });
                 return deferred.promise;
            }; 
        
        
            return {
                getFundingModelTypes: getFundingModelTypes,
                getSavedSearchbyPerson: getSavedSearchbyPerson,
                deleteSavedSearchbyPerson: deleteSavedSearchbyPerson
            };
        } 

    ]);
}(angular, schoolwork12));